"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpResponseToJSON = exports.OtpResponseFromJSONTyped = exports.OtpResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function OtpResponseFromJSON(json) {
    return OtpResponseFromJSONTyped(json, false);
}
exports.OtpResponseFromJSON = OtpResponseFromJSON;
function OtpResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'otpSessionId': !runtime_1.exists(json, 'otpSessionId') ? undefined : json['otpSessionId'],
        'needCommMethod': !runtime_1.exists(json, 'needCommMethod') ? undefined : json['needCommMethod'],
    };
}
exports.OtpResponseFromJSONTyped = OtpResponseFromJSONTyped;
function OtpResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'otpSessionId': value.otpSessionId,
        'needCommMethod': value.needCommMethod,
    };
}
exports.OtpResponseToJSON = OtpResponseToJSON;
//# sourceMappingURL=OtpResponse.js.map